module.exports = __webpack_public_path__ + "media/images/smart_phone/item/rate_2-82c26bac0169101d2cc6e28523b4dd13.png";